import type { SVGProps } from 'react'
const SvgToc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      stroke="#0F141E"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M3.75 6.25h20.5M3.75 16.25h20.5M3.75 11.25h16.5M3.75 21.25h16.5"
    />
  </svg>
)
export default SvgToc
